import { useAtomValue } from 'jotai';
import { FC, PropsWithChildren } from 'react';

import { sizeSimpleLayoutState } from '../../SimpleLayout.states';
import { Root } from './Top.styles';

/**
 * A section located on top of "Content"
 */
export const Top: FC<PropsWithChildren> = (props) => {
    const { children } = props;

    const size = useAtomValue(sizeSimpleLayoutState);

    return (
        <Root gridArea='top' $size={size}>
            {children}
        </Root>
    );
};

Top.displayName = 'Top';
